(() => {
  angular.module('app').controller('host.views.overutilizedReport.index', OverutilizedReportController);

  OverutilizedReportController.$inject = ['abp.services.app.report'];

  function OverutilizedReportController(reportSvc) {
    const vm = this;
    vm.dataExportRecordName = 'OverutilizedReport';
    vm.generateButtonType = App.localize('ExportToExcel');
    vm.enqueuing = 0;
    
    vm.getOverutilizedReport = getOverutilizedReport;
    init();

    function init() {}
    function getOverutilizedReport() {
      vm.enqueuing += 1;
      reportSvc
        .enqueueGenerateOverutilizedExcelReportJob()
        .success(() => {
          vm.refresh();
        })
        .finally(() => {
          vm.enqueuing -= 1;
        });
    }
  }
})();
